import { createFileRoute } from "@tanstack/react-router";
import { useAdminOrgDetail, useAdminOrgUpdate, useAdminOrgDelete } from "@/hooks/use-admin-orgs";
import { OrgDetailHeader } from "@/components/org-detail-header";
import { OrgMembersTable } from "@/components/org-members-table";
import { AdminFacilitiesTable } from "@/components/admin-facilities-table";
import { AdminMonitoringLocationsTable } from "@/components/admin-monitoring-locations-table";
import { OrgEditForm } from "@/components/org-edit-form";

export const Route = createFileRoute("/_admin/orgs/$orgId")({
  component: OrgDetailPage,
});

function OrgDetailPage() {
  const { orgId } = Route.useParams();
  const { data: org, isLoading, error } = useAdminOrgDetail(orgId);
  const updateMutation = useAdminOrgUpdate();
  const deleteMutation = useAdminOrgDelete();

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div className="h-6 w-24 animate-pulse rounded bg-slate-200" />
        <div className="h-64 animate-pulse rounded-xl bg-slate-100" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-700">
        Failed to load organization: {error.message}
      </div>
    );
  }

  if (!org) {
    return (
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 text-slate-600">
        Organization not found.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <OrgDetailHeader org={org} />
      <OrgMembersTable orgId={orgId} />
      <AdminFacilitiesTable orgId={orgId} />
      <AdminMonitoringLocationsTable orgId={orgId} />
      <OrgEditForm
        org={org}
        orgId={orgId}
        updateMutation={updateMutation}
        deleteMutation={deleteMutation}
      />
    </div>
  );
}
